import styled from 'styled-components';
import { StyledInput } from '../JRCStyledInput';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { JRCIconButton } from 'components/JRCIconButton/JRCIconButton';

export const IconBefore = styled(JRCIcon)`
    position: absolute;
    left: 8px;
    top: 10px;
`;

export const IconAfter = styled(JRCIconButton)`
    position: absolute;
    right: 1px;
    top: 1px;
    width: 38px;
    height: 38px;
`;

export const InputIconButton = styled(StyledInput)<{ hasIconButtonAfter: boolean }>`
    width: ${(props) => (props?.width ? `${props.width} !important` : '100%')};
    padding: 8px ${(props) => (props?.hasIconButtonAfter ? '40px' : '16px')} 8px 38px !important;
`;

export const InputTextStyled = styled(StyledInput)`
    width: '100%';
`;

export const ContainerInputTextIconButton = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: relative;
`;
